import { API_URL } from '../../../constants';

export const API_MODEL_TYPE_GROUP = 'group';

export const GROUPS_API_PATH = `${API_URL}/groups`;
